import { FC, HTMLAttributes } from 'react'
import styled from 'styled-components/macro'

export type IconType = FC<HTMLAttributes<SVGElement> & { className?: string }>

export const Svg = styled.svg`
  display: inline-block;
  width: 16px;
  overflow: visible;
`

export const OpenDirectIcon: IconType = ({ className = '' }) => (
  <Svg viewBox="0 0 15 20" className={className}>
    <path
      d="M14.5515 20H0.551514V18H14.5515V20ZM7.55151 16L1.55151 10L2.96151 8.59L6.55151 12.17V0H8.55151V12.17L12.1415 8.59L13.5515 10L7.55151 16Z"
      fill="currentColor"
    />
  </Svg>
)
